import { GroupOffersBy, GroupOffersByQuery, ShowHiddenOffersQuery as ShowHiddenOffersQuery, IOffersAdminResponse, TOffer } from "types/offers-temporary";
import http from "./http";
import { IApp, IDomain, IDomainsBuyRequestResponse, INamecheapBuyResult, ISectionsList, IOffersSection, IUpsertAppRequest } from "@bprotsyk/aso-core";
const DEPLOY_STATUS = "delpoy_status";

// Функція для отримання WebSocket URL на основі базової URL з http
const getWebSocketUrl = (path: string): string => {
  // Отримуємо базовий URL з http
  const baseUrl = http.defaults.baseURL || '';
  
  // Визначаємо протокол для WebSocket
  let wsProtocol = 'ws://';
  if (baseUrl.startsWith('https://')) {
    wsProtocol = 'wss://';
  }
  
  // Видаляємо http:// або https:// з URL
  const urlWithoutProtocol = baseUrl
    .replace('https://', '')
    .replace('http://', '');
  
  // Видаляємо завершальний слеш з базового URL, якщо він є
  const cleanBaseUrl = urlWithoutProtocol.endsWith('/') 
    ? urlWithoutProtocol.slice(0, -1) 
    : urlWithoutProtocol;
  
  // Переконуємось, що шлях починається зі слеша
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  
  // Отримуємо JWT токен з localStorage
  const token = localStorage.getItem('token');
  
  // Додаємо токен до URL як query параметр
  const urlWithToken = token ? `${cleanPath}?token=${encodeURIComponent(token)}` : cleanPath;
  
  // Повертаємо повний URL для WebSocket
  return `${wsProtocol}${cleanBaseUrl}${urlWithToken}`;
};

//TODO add  IDomainSetupResult (Cannot find name 'IDomainSetupResult')
interface IDomainSetupResult {
  succeed: string[],
  failed: string[]
}
// TODO add interface for IParams (aco-core)
interface IParamsAddDomain {
  domains: string[],
  ip: string,
}

interface IParamsBuyDomain {
  domains: string[];
  duration?: number;
  ip: string;
}

interface IParamsEditDomain {
  domains: DNSRecord[];
  duration?: number;
  ip: string;
}

interface IParamsRenewDomain {
  domainName: string;
  years?: number;
  promotionCode?: string;
  isPremiumDomain?: boolean;
  premiumPrice?: number;
}


type DNSRecords = TXTRecord | MXRecord;
// Інтерфейс для TXT-записів
interface TXTRecord extends DNSRecord {
  type: "TXT";
}

// Інтерфейс для статичного розгортання
export interface IStaticDeploy {
  file: any,
  name: string,
}

// Інтерфейс для MX-записів
interface MXRecord extends DNSRecord {
  type: "MX";
  priority: number;
}

interface DNSRecord {
  type: string;
  value: string;
}

export interface IUpsertStubRequest {
  appId: number,
  name: string,
  templateUpsert: {
    idKey: string,
    gameNameKey: string,
    bgKey: string,
    fgKey: string,
    textKey: string,
  },
  jsonEdit: any,
  // offersStubParams removed - field no longer exists
  images: File[],
  treeData: Record<string, any>[]
}

let appsWebSocket: WebSocket | null = null;
let appsCallbacks: Map<string, (apps: IApp[]) => void> = new Map();

let appsUpdateSubscribers: Set<(apps: IApp[]) => void> = new Set();


const subscribeToAppsUpdates = (callback: (apps: IApp[]) => void): () => void => {
  appsUpdateSubscribers.add(callback);
  
  connectAppsWebSocket('apps/ws/app-list');
  
  if (appsWebSocket && appsWebSocket.readyState === WebSocket.OPEN) {
    console.log('Запит початкового списку додатків при підписці');
    appsWebSocket.send(JSON.stringify({
      type: 'getAppList',
      requestId: 'subscribe_' + Date.now().toString(),
    }));
  } else {
    // Якщо підключення не активне, запитуємо список після підключення
    console.log('Запитаємо дані після встановлення з\'єднання');
    setTimeout(() => {
      if (appsWebSocket && appsWebSocket.readyState === WebSocket.OPEN) {
        console.log('Запит початкового списку додатків після підключення WebSocket');
        appsWebSocket.send(JSON.stringify({
          type: 'getAppList',
          requestId: 'subscribe_delayed_' + Date.now().toString(),
        }));
      }
    }, 1500);
  }
  
  return () => {
    appsUpdateSubscribers.delete(callback);
  };
};

const connectAppsWebSocket = (path: string) => {
  if (appsWebSocket && (appsWebSocket.readyState === WebSocket.OPEN || appsWebSocket.readyState === WebSocket.CONNECTING)) {
    console.log(`WebSocket для ${path} вже підключений або підключається`);
    return;
  }

  const wsUrl = getWebSocketUrl(path);
  console.log(`Створюємо нове WebSocket-з'єднання: ${wsUrl}`);
  appsWebSocket = new WebSocket(wsUrl);

  appsWebSocket.onopen = () => {
    console.log(`WebSocket з'єднання для ${path} встановлено`);
  };

  appsWebSocket.onmessage = (event) => {
    const message = JSON.parse(event.data);
    console.log(`Отримано повідомлення від WebSocket, тип: ${message.type}`);
    
    switch (message.type) {
      case 'appListAllUpdated':
      case 'appListUpdated':
        console.log(`Отримано оновлення списку додатків: ${message.type}`);
        
        let appsArray: IApp[];
        if (Array.isArray(message.data)) {
          appsArray = message.data;
        } else if (typeof message.data === 'object' && message.data !== null) {
          appsArray = Object.values(message.data);
        } else {
          appsArray = [];
          console.error('Неочікуваний формат даних від WebSocket:', message.data);
        }
        
        if (appsCallbacks.size > 0) {
          console.log(`Відправка даних у ${appsCallbacks.size} callback(s)`);
        appsCallbacks.forEach((callback) => {
            callback(appsArray);
          });
        }
        
        if (appsUpdateSubscribers.size > 0) {
          console.log(`Відправка даних у ${appsUpdateSubscribers.size} підписників`);
          appsUpdateSubscribers.forEach(subscriber => {
            subscriber(appsArray);
          });
        }
        break;
      
      case 'connected':
        console.log('Отримано підтвердження підключення до WebSocket');
        setTimeout(() => {
          if (appsWebSocket && appsWebSocket.readyState === WebSocket.OPEN) {
            console.log('Запит даних після підтвердження підключення');
            appsWebSocket.send(JSON.stringify({
              type: 'getAppList',
              requestId: 'post_connected_' + Date.now().toString(),
            }));
          }
        }, 500);
        break;
        
      default:
        console.log(`Необроблений тип повідомлення: ${message.type}`);
    }
  };

  appsWebSocket.onerror = (error) => {
    console.error('WebSocket помилка:', error);
  };

  appsWebSocket.onclose = () => {
    console.log(`WebSocket з'єднання для ${path} закрито`);
    // Передаємо path під час повторного підключення
    setTimeout(() => connectAppsWebSocket(path), 3000);
  };
};

const getApps = async (filter?: string, activeOnly: boolean = true): Promise<IApp[]> => {
  return new Promise((resolve) => {
    const requestId = Date.now().toString();
    
    appsCallbacks.set(requestId, (apps: any) => {
      // Перевіряємо формат даних і забезпечуємо повернення масиву
      let appsArray: IApp[];
      
      if (Array.isArray(apps)) {
        appsArray = apps;
      } else if (typeof apps === 'object' && apps !== null) {
        // Якщо прийшов об'єкт, перетворюємо його на масив
        appsArray = Object.values(apps);
      } else {
        // Якщо прийшло щось інше, повертаємо порожній масив
        appsArray = [];
        console.error('Неочікуваний формат даних від WebSocket:', apps);
      }
      
      resolve(appsArray);
      appsCallbacks.delete(requestId);
    });
    
    connectAppsWebSocket('apps/ws/app-list');
    
    if (appsWebSocket && appsWebSocket.readyState === WebSocket.OPEN) {
      appsWebSocket.send(JSON.stringify({
        type: 'getAppList',
        requestId,
        filter,
        activeOnly
      }));
    } else {
      setTimeout(() => {
        if (appsWebSocket && appsWebSocket.readyState === WebSocket.OPEN) {
          appsWebSocket.send(JSON.stringify({
            type: 'getAppList',
            requestId,
            filter,
            activeOnly
          }));
        } else {
          appsCallbacks.delete(requestId);
          resolve([]);
        }
      }, 1000);
    }
  });
};




const getAllOffers = async (groupBy: string, showHidden: boolean, showActive: boolean) => {
  const response = await http.get<IOffersAdminResponse>(`offers?groupBy=${groupBy}&showHidden=${showHidden}`)

  return response.data
}

const getDomains = async (filter?: string) => {
  const response = await http.get<IDomain[]>(`/domains/${filter ? filter : ''}`);
  return response.data;
}

const getDomainBalance = async () => {
  const response = await http.get<number>(`/domains/balance`);
  return response.data;
}




const addDomain = async (params: IParamsAddDomain) => {
  try {
    const response = await http.post<IDomainSetupResult>(`/domains/add`, params);
    return response;
  } catch (error) {
    console.error(error)
  }
}

const getBuyDomain = async (params: IParamsBuyDomain) => {
  try {
    const response = await http.post<IDomainsBuyRequestResponse>(`/domains/create-buy-request`, params);
    return response;
  } catch (error) {
    console.error(error);
  }
}

const buyDomains = async (params: string) => {
  try {
    const response = await http.post<INamecheapBuyResult>(`/domains/buy?requestId=${params}`);
    return response;
  } catch (error) {

  }
}

const editDomain = async (params: Partial<IDomain>) => {
  try {
    const response = await http.put<IDomain>(`/domains/edit`, params);
    return response;
  } catch (error) {
    console.error(error)
  }
}

const renewDomain = async (params: IParamsRenewDomain) => {
  try {
    const response = await http.post(`/domains/renew`, params);
    return response.data;
  } catch (error) {
    console.error('Domain renewal error:', error);
    throw error;
  }
}

export const uploadStatic = async (body: IStaticDeploy) => {
  try {
    const file = body.file[0].blobFile;
    const formData = new FormData();
    formData.append('name', body.name);
    formData.append('file', file);
    const { blobFile } = body.file;
    console.log(blobFile);
    const response = await http.post(`/domains/upload-files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (response.status == 200) {
      sessionStorage.setItem(DEPLOY_STATUS, "true");
    } else {
      sessionStorage.setItem(DEPLOY_STATUS, "false");
    }
    return response;
  } catch (error) {
    console.error(error)
    sessionStorage.setItem(DEPLOY_STATUS, "false");
  }
}

// Sections Lists CRUD methods
const getSectionsLists = async () => {
  try {
    const response = await http.get<ISectionsList[]>('/offers/sections-lists');
    return response.data;
  } catch (error) {
    console.error('Error fetching sections lists:', error);
    throw error;
  }
}

const upsertSectionsList = async (sectionsList: ISectionsList) => {
  try {
    const response = await http.post<ISectionsList>('/offers/sections-lists', sectionsList);
    return response.data;
  } catch (error) {
    console.error('Error upserting sections list:', error);
    throw error;
  }
}

const deleteSectionsList = async (listId: number) => {
  try {
    const response = await http.delete(`/offers/sections-lists/${listId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting sections list:', error);
    throw error;
  }
}

// Sections CRUD methods
const getSections = async () => {
  try {
    const response = await http.get<IOffersSection[]>('/offers/sections');
    return response.data;
  } catch (error) {
    console.error('Error fetching sections:', error);
    throw error;
  }
}

const createSection = async (section: IOffersSection) => {
  try {
    const response = await http.post<IOffersSection>('/offers/sections', section);
    return response.data;
  } catch (error) {
    console.error('Error creating section:', error);
    throw error;
  }
}

const updateSection = async (sectionId: number, section: Partial<IOffersSection>) => {
  try {
    const response = await http.put<IOffersSection>(`/offers/sections/${sectionId}`, section);
    return response.data;
  } catch (error) {
    console.error('Error updating section:', error);
    throw error;
  }
}

const deleteSection = async (sectionId: number) => {
  try {
    const response = await http.delete(`/offers/sections/${sectionId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting section:', error);
    throw error;
  }
}


const upsertStub = async (body: IUpsertStubRequest) => {
  const formData = new FormData();

  // Додаємо файли до formData
  body.images?.forEach(file => {
    if (file) {
      formData.append('files[]', file);
    }
  });

  // Додаємо інші дані
  formData.append('appId', body?.appId?.toString() || "");
  formData.append('name', body.name);
  formData.append('templateUpsert', JSON.stringify(body.templateUpsert));
  formData.append('jsonEdit', JSON.stringify(body.jsonEdit));
  formData.append('treeData', JSON.stringify(body.treeData));

  // Перегляд вмісту FormData
  for (let pair of formData.entries()) {
    console.log(pair[0] + ', ' + pair[1]);
  }

  try {
    const response = await http.post(`/apps/offer-stub/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  } catch (error) {
    console.error('Error uploading data and files:', error);
    throw error;
  }
}

const upsertApp = async (app: IApp | IUpsertAppRequest) => {
  const response = await http.post<IApp>(`/apps/upsert`, app);
  return response;
}

const getAppStub = async (appId: number, name: string) => {
  const response = await http.get(`/apps/offer-stub/`, { params: { appId, name } });
  return response;
}


const getAppInfo = async (appId: number) => {
  const response = await http.get(`/apps/app-info/${appId}`);
  return response.data;
}

const updateAppStatuses = async (appStatuses: Array<{ appId: number; status: string }>) => {
  const response = await http.post('/apps/update-statuses', { appStatuses });
  return response.data;
};

export const PanelService = { getAllOffers, getDomains, getDomainBalance, addDomain, getBuyDomain, buyDomains, editDomain, renewDomain, getApps, uploadStatic, upsertApp, getAppStub, upsertStub, getAppInfo, subscribeToAppsUpdates, getSectionsLists, upsertSectionsList, deleteSectionsList, getSections, createSection, updateSection, deleteSection, updateAppStatuses }


